type State = { isOpen: boolean; errorMessage: string; correlationId: string; errorCode: string };
type Listener = (state: State) => void;

let isOpen = false;
let errorMessage = '';
let correlationId = '';
let errorCode = '';
let onCloseCallback: (() => void) | undefined;

const listeners: Set<Listener> = new Set();

function notifyListeners() {
  listeners.forEach((listener) => listener({ isOpen, errorMessage, correlationId, errorCode }));
}

export function showErrorModal(message: string, corrId?: string, code?: string, onClose?: () => void) {
  errorMessage = message;
  correlationId = corrId || '';
  errorCode = code || '';
  onCloseCallback = onClose;
  isOpen = true;
  notifyListeners();
}

export function closeErrorModal() {
  isOpen = false;
  errorMessage = '';
  correlationId = '';
  errorCode = '';

  const callback = onCloseCallback;
  onCloseCallback = undefined;

  notifyListeners();

  if (callback) {
    callback();
  }
}

export function subscribeToErrorModal(listener: Listener): () => void {
  listeners.add(listener);
  listener({ isOpen, errorMessage, correlationId, errorCode });
  return () => listeners.delete(listener);
}
